import React from 'react';
import { Link } from 'react-router-dom';
import AddAulaButton from './Aulas/AddAulaButton';
import AddCursoButton from './Cursos/AddCursoButton';
import AddUsuarioButton from './Usuarios/AddUsuarioButton';

const ActionButtons = ({
	nivel,
	aulasManager,
	cursosManager,
	usuariosManager
}) => {
	return (
		<div className="container-fluid mt-3 mt-md-0">
			<div className="row mb-4">
				{nivel === 'Administrador' && (
					<AddAulaButton openAddAulaModal={aulasManager.openAddAulaModal} />
				)}
				{nivel === 'Administrador' && (
					<AddCursoButton openAddCursoModal={cursosManager.openAddCursoModal} />
				)}
				{(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
					<AddUsuarioButton openAddUsuarioModal={usuariosManager.openAddUsuarioModal} />
				)}

				{nivel === 'Gestor' && (
					<div className="col-12 col-xl-3 col-md-6 py-1">
						<Link to="/provas-extras">
							<button
								type="button"
								className="d-flex align-items-center justify-content-center btn btn-primary text-white w-100 fw-semibold"
							>
								<i className="bi bi-journal-medical fs-4 me-2"></i> Provas Extras
							</button>
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default ActionButtons; 